import React, {Component} from 'react'
import Logo from '../Logo'
import Panel from '../Panel'
import {style} from 'glamor'
import * as colors from '../../colors'
import {Arrow} from 'reline'
import Page from './Page'
import PageTitle from '../PageTitle'
import {ButtonCircle} from 'rebass'
import Facebook from 'react-icons/lib/fa/facebook'
import Twitter from 'react-icons/lib/fa/twitter'
import Instagram from 'react-icons/lib/fa/instagram'
import LinkedIn from 'react-icons/lib/fa/linkedin'


export default class extends Component {

  shouldComponentUpdate(){
    return false
  }

  render(){
    return (
      <Page>
        <PageTitle>Contact</PageTitle>
        <div
          data-animate
          {...style({
            marginTop: '4rem',
            marginBottom: '1rem',
            fontSize: '2rem'
          })}
        >
          <Logo/>
        </div>

        <div
          {...style({
            marginBottom: '8rem',
          })}
        >
          <p
            data-animate
            {...style({
              margin: '0 0 1rem'
            })}
          >
            +33 6 03 44 73 87
          </p>
          <p
            data-animate
            {...style({
              margin: '0 0 2rem'
            })}
          >
            eric.helias@buyideas.fr
          </p>

          <p
            data-animate
            {...style({
              margin: '0 0 10rem'
            })}
          >
            <a
              {...style({
                marginRight: '1rem'
              })}
              href="https://www.facebook.com/eric.helias"
              target="_blank"
            >
              <ButtonCircle
                size={40}
                color={colors.white}
                backgroundColor={colors.yellow}
              >
                <Facebook/>
              </ButtonCircle>
            </a>
            <a
              {...style({
                marginRight: '1rem'
              })}
              href="https://twitter.com/erichelias1"
              target="_blank"
            >
              <ButtonCircle
                size={40}
                color={colors.white}
                backgroundColor={colors.yellow}
              >
                <Twitter/>
              </ButtonCircle>
            </a>
            <a
              {...style({
                marginRight: '1rem'
              })}
              href="https://www.instagram.com/erichelias/"
              target="_blank"
            >
              <ButtonCircle
                size={40}
                color={colors.white}
                backgroundColor={colors.yellow}
              >
                <Instagram/>
              </ButtonCircle>
            </a>
            <a
              {...style({
                marginRight: '1rem'
              })}
              href="https://fr.linkedin.com/in/eric-helias-97884235"
              target="_blank"
            >
              <ButtonCircle
                size={40}
                color={colors.white}
                backgroundColor={colors.yellow}
              >
                <LinkedIn/>
              </ButtonCircle>
            </a>
          </p>
        </div>

      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/Contact.js
 **/